import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'


const propTypes = {
  reactTableColumn: PropTypes.shape({
    filterValue : PropTypes.any,
    setFilter   : PropTypes.func
  }),
  portalMenu: PropTypes.bool,
  options: PropTypes.array
}

/**
 * Multiselect filter hooked up to ReactTable filter.
 * Allow user input text to filter the records
 *
 * it will pass `column` properties from ReactTable. It consist:
 * @param {func} setFilter  Used to update the filter value for this column
 * @param {func} options  Multiselect options
 *
 */
const MultiselectColumnFilter = ({
  reactTableColumn: {
    filterValue,
    setFilter
  },
  options,
  portalMenu = false
}) => {
  const filterValues = Array.isArray(filterValue) ? filterValue : (filterValue ? [ filterValue ] : [])
  const selectedOptions = options.filter((option) => filterValues.includes(option.value))

  const transformSelectedOptionsToValues = (event) => event.map((item) => item.value)

  return (
    <>
      <Select
        menuPortalTarget={ portalMenu && typeof document !== 'undefined' ? document.body : undefined }
        menuPosition={ portalMenu ? 'fixed' : 'absolute' }
        styles={ portalMenu ? { menuPortal: (base) => ({ ...base, zIndex: 1060 }) } : undefined }
        value={ selectedOptions || [] }
        options={ options }
        isMulti={ true }
        placeholder={ 'Select multi option' }
        onChange={ (event) => {
          setFilter(event ? transformSelectedOptionsToValues(event) : [])
        } }
      />
    </>
  )
}

MultiselectColumnFilter.propTypes = propTypes

export default MultiselectColumnFilter
